import { List, styled } from '@mui/material';
import { alpha } from '@mui/system';

const PREFIX = 'ListItems';

export const classes = {
  root: `${PREFIX}-root`,
  item: `${PREFIX}-item`,
  itemIcon: `${PREFIX}-itemIcon`,
  itemText: `${PREFIX}-itemText`,
  subMenu: `${PREFIX}-subMenu`,
  subitem: `${PREFIX}-subitem`,
  subitemText: `${PREFIX}-subitemText`,
  subItemAction: `${PREFIX}-subItemAction`,
  subItemIcon: `${PREFIX}-subItemIcon`,
  service: `${PREFIX}-service`,
  serviceIcon: `${PREFIX}-serviceIcon`,
  rightDropIcon: `${PREFIX}-rightDropIcon`,
  overflowtext: `${PREFIX}-overflowtext`,
  skeleton: `${PREFIX}-skeleton`,
  activeSubMenuItem: `${PREFIX}-activeSubMenuItem`,
};

export const StyledList = styled(List)(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: '0px',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    overflow: 'hidden',
  },

  // items
  [`& .${classes.item}`]: {
    color: theme.palette.white,
    padding: theme.spacing(2),
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
    },
    borderRadius: 0,
  },

  [`& .${classes.itemIcon}`]: {
    color: theme.palette.white,
    marginRight: theme.spacing(2),
    minWidth: '24px',
    width: '24px',
  },

  [`& .${classes.itemText}`]: {
    '& .MuiTypography-body1': {
      fontWeight: 700,
      color: theme.palette.white,
    },
    textTransform: 'capitalize',
  },

  // subitems
  [`& .${classes.subMenu}`]: {},

  [`& .${classes.subitem}`]: {
    borderRadius: 0,
    padding: `${theme.spacing(1)} ${theme.spacing(2)} !important`,
    backgroundColor: alpha(theme.palette.primary[600], 0.3),
    cursor: 'pointer !important',

    '& .MuiListItemIcon-root': {
      minWidth: theme.spacing(5),
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary[200],
    },
    '&.Mui-selected .MuiTypography-root': {
      fontWeight: '700',
    },
    textTransform: 'capitalize',
    position: 'relative',

    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },

  [`& .${classes.subitemText}`]: {
    '& .MuiTypography-body1': {
      color: 'white',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '0.85rem',
    },
  },

  [`& .${classes.subItemAction}`]: {
    '& .MuiTypography-body1': {
      color: theme.palette.primary.light,
    },

    '&:hover .MuiTypography-body1': {
      color: 'white',
    },
  },

  [`& .${classes.subItemIcon}`]: {
    color: theme.palette.primary.light,
    '&:hover .pin-company': {
      opacity: 1,
    },
  },

  // services
  [`& .${classes.service}`]: {
    paddingLeft: theme.spacing(7),
    backgroundColor: 'rgba(0,0,0, 0.1)',

    '&.Mui-selected': {
      backgroundColor: 'rgba(0,0,0, 0.10)',
    },
    '&.Mui-selected .MuiTypography-root': {
      fontWeight: '700',
    },
  },

  [`& .${classes.serviceIcon}`]: {
    opacity: 0.5,
    minWidth: '18px',

    '& .MuiSvgIcon-root': {
      width: '18px',
    },
  },

  [`& .${classes.rightDropIcon}`]: {
    color: 'white',
    opacity: 0.5,
    minWidth: 0,
  },

  [`& .${classes.overflowtext}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  // skeleton
  [`& .${classes.skeleton}`]: {
    backgroundColor: 'rgba(255,255,255, 25%)',
  },

  [`& .${classes.activeSubMenuItem}`]: {
    '& .MuiListItemText-primary': {
      fontWeight: 900,
    },
  },
}));